module.exports = "pegasus/assets/home-bg.png";